import listesPaginees from '@/api/parametres/_listes-paginees.js'
import { nouvelleListe, chargerPage, rechercherDiffere, rechargerDepuisDebut } from '@/utils/liste-paginee.js'

export default {
    name: 'tarif-acte',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_acte_tarif_data: Object,
        // Filtre de l'en-tête : '' (tous) | 'normal' | 'urgence'
        type_facturation_filtre: {
            type: String,
            default: ''
        },
        // Section affichée par le filtre Prestation de l'en-tête
        visible: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            is_printing: false,

            // Liste paginée côté serveur (deux lignes par acte sans filtre de type : normal puis urgence)
            liste: nouvelleListe(),
            // Assurance de la liste : 0 au chargement, puis l'assurance choisie dans l'en-tête
            assurance_id_liste: 0,
            page_demandee: 0,
            a_recharger: false,
        }
    },

    watch: {
        assurance_select() {
            this.assurance_id_liste = this.assurance_select.compagnie_id
            this.rechargerDepuisDebut()
        },

        type_facturation_filtre() {
            this.rechargerDepuisDebut()
        },

        // Section de nouveau affichée : rechargée si l'assurance / le type a changé entre-temps
        visible() {
            if (this.visible && this.a_recharger) {
                this.charger()
            }
        },

        editing_acte_tarif_data() {
            this.saveTarifActe()
        }
    },

    computed: {
        // Aucun acte (hors recherche en cours)
        est_vide() {
            return !this.liste.chargement && !this.liste.erreur && this.liste.total == 0 && this.liste.q == ''
        },
    },

    mounted() {
        // Liste des actes
        this.charger()
    },

    methods: {
        /**
         * Appel API : avec page / per_page / q => une page ; sans => la liste complète (impression)
         * @param {*} params
         */
        appel(params) {
            return listesPaginees.tarifActes(Object.assign({ assurance_id: this.assurance_id_liste }, params))
        },

        /**
         * Charge la page courante
         */
        charger() {
            this.a_recharger = false
            this.page_demandee = this.liste.page

            return chargerPage(this.liste, (params) => {
                if (this.type_facturation_filtre != '') {
                    params.type_facturation = this.type_facturation_filtre
                }
                return this.appel(params)
            })
        },

        /**
         * Retour à la page 1 (assurance, type changés) ; différé au prochain affichage si la section est masquée
         */
        rechargerDepuisDebut() {
            if (this.visible) {
                rechargerDepuisDebut(this.liste, () => this.charger())
            } else {
                this.liste.page = 1
                this.page_demandee = 1
                this.a_recharger = true
            }
        },

        /**
         * Pagination (@input) : charge la page choisie (ignore la remise à 1 faite par le rechargement)
         */
        changerPage() {
            if (this.liste.page != this.page_demandee) {
                this.charger()
            }
        },

        rechercher() {
            rechercherDiffere(this.liste, () => this.charger())
        },

        /**
         * Libellé affiché d'un type de facturation ('normal' => 'Normal')
         * @param {*} type_facturation
         */
        libelleTypeFacturation(type_facturation) {
            if (!type_facturation) {
                return ''
            }
            return type_facturation.charAt(0).toUpperCase() + type_facturation.slice(1)
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifActe', tarif_data)
        },

        saveTarifActe() {
            this.$store.dispatch("saveTarifActe", this.editing_acte_tarif_data).then((response) => {
                if (response.success) {
                    // Page courante rechargée
                    this.charger()

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        /**
         * Impression : liste complète des actes (sans pagination), filtrée selon le type de l'en-tête
         */
        printTarifActe() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            this.appel({}).then((reponse) => {
                let prestations = Array.isArray(reponse) ? reponse : ((reponse && Array.isArray(reponse.data)) ? reponse.data : [])

                if (this.type_facturation_filtre != '') {
                    prestations = prestations.filter((acte) => {
                        return !acte.type_facturation || acte.type_facturation == this.type_facturation_filtre
                    })
                }

                const data = {
                    data_type: 'acte',
                    prestations: prestations
                }

                this.$emit('emitPrintTarif', data)
            }).catch(() => {
                this.errorToast("Une erreur s'est produite lors du chargement de la liste à imprimer !")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}
